import Input, { Password, InputNumber, TextArea } from "./Input"

export default Input
export { Password, InputNumber, TextArea }
